export default function Hero() {
  return (
    <section id="home" className="relative flex min-h-screen w-full items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20wide%20anime%20illustration%20of%20a%20beautiful%20girl%20with%20long%20orange%20hair%20standing%20on%20a%20cliff%20overlooking%20a%20warm%20sunset%20ocean%2C%20tangerine%20and%20golden%20sky%2C%20flowing%20hair%20in%20the%20wind%2C%20high%20quality%20anime%20art%2C%20warm%20epic%20atmosphere%2C%20sense%20of%20adventure%20and%20freedom%2C%20rich%20golden%20lighting%2C%20detailed%20background%20with%20distant%20horizon&width=1600&height=1000&seq=hero-nami&orientation=landscape"
          alt="娜美同人插画壁纸图鉴首屏"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/55 to-background-50"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 pb-20 pt-28 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-400/40 bg-primary-500/10 px-4 py-1.5 text-sm text-primary-300">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary-400"></span>
          每日更新 · 高清画师作品
        </span>

        <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-foreground-50 md:text-6xl">
          娜美同人插画<span className="text-primary-400">壁纸图集</span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-foreground-200 md:text-lg">
          为你整理娜美同人插画、壁纸与画集资源，收录多位画师的高清图片，支持按风格与角色浏览，每日更新，打开页面即可收藏下载心仪的美图。
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#latest"
            className="w-full whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            浏览最新图集
          </a>
          <a
            href="#styles"
            className="w-full whitespace-nowrap rounded-md border border-background-300/60 bg-background-100/40 px-7 py-3 text-sm font-medium text-foreground-100 transition-colors hover:bg-background-200/50 sm:w-auto"
          >
            按风格筛选
          </a>
        </div>

        <div className="mx-auto mt-12 grid max-w-2xl grid-cols-3 divide-x divide-background-300/50 rounded-xl border border-background-300/40 bg-background-100/40 px-2 py-4 backdrop-blur-sm">
          {[
            { num: '1280+', label: '高清作品' },
            { num: '86', label: '签约画师' },
            { num: '365', label: '每日更新' },
          ].map((item) => (
            <div key={item.label} className="px-2 text-center">
              <p className="font-heading text-2xl font-bold text-primary-400 md:text-3xl">{item.num}</p>
              <p className="mt-1 text-xs text-foreground-300 md:text-sm">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}